export default function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/d3-array/src/threshold/sturges.js
// module id = 129
// module chunks = 0